import api, { api_v2 } from "./api"
import type {
  MentoringDataType,
  MentoringParamsType,
  MentoringResponsePayload,
  FetchSpecialistPayload,
  MentorsParamsType,
} from "../types/mentoring"

export const getMentorings = async (
  emp_id: string,
  params: MentoringParamsType | null = null
): Promise<MentoringResponsePayload> => {
  try {
    const response = await api.get<MentoringResponsePayload>(`/mentorias/${emp_id}/mentorias`, {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error(`Error fetching mentorings for emp_id ${emp_id}:`, error)

    throw error
  }
}

export const getMentoringsV2 = async (params: MentoringParamsType | null = null): Promise<void> => {
  try {
    const response = await api_v2.get(`/mentoria/mentorias`, {
      params,
    })

    return response.data
  } catch (error) {
    console.error(`Error fetching mentorings for emp_id ${emp_id}:`, error)

    throw error
  }
}

export const getAllMentorings = async (
  params: MentoringParamsType | null = null
): Promise<MentoringResponsePayload> => {
  try {
    const response = await api.get<MentoringResponsePayload>(`/mentorias/listar-mentorias`, {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error(`Error fetching mentorings for emp_id:`, error)

    throw error
  }
}

export const getAllMentoringsV2 = async (
  params: MentoringParamsType | null = null
): Promise<any> => {
  try {
    const response = await api_v2.get(`/mentoria/mentorias`, {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error(`Error fetching mentorings for emp_id:`, error)

    throw error
  }
}

export const getAllMentors = async (emp_id: string, params: MentoringParamsType | null = null) => {
  try {
    const response = await api.get(`/mentorias/${emp_id}/mentores`, {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error(`Error fetching mentorings for emp_id ${emp_id}:`, error)

    throw error
  }
}

// originador_id: pes_id do logado
// mentor_id: id do mentor que está sendo atribuido
// emp_id: id da empresa que esta sendo atribuida o mentor

export const setSpecialistMentors = async (
  originador_id: number,
  mentor_id: number,
  emp_id: number
): Promise<MentoringResponsePayload> => {
  try {
    const response = await api.post<MentoringResponsePayload>("/mentorias/mentor-especialista", {
      originador_id,
      mentor_id,
      emp_id,
    })

    return response.data
  } catch (error) {
    console.error(error)

    throw error
  }
}

export const unlinkSpecialistMentors = async (
  originador_id: number,
  mentor_id: number,
  emp_id: number
): Promise<MentoringResponsePayload> => {
  try {
    const response = await api.delete(
      `/mentorias/${emp_id}/mentor-especialista/${mentor_id}?originador_id=${originador_id}`
    )

    return response.data
  } catch (error) {
    console.error(error)

    throw error
  }
}

export const getMentors = async (params: MentorsParamsType | null = null) => {
  try {
    const response = await api.get(`/mentorias/mentores`, {
      params: params,
    })

    return response.data
  } catch (error) {
    console.error(error)

    throw error
  }
}

export const getMentorsV2 = async (params?: { all?: boolean; search?: string }) => {
  try {
    const response = await api_v2.get(`/mentoria/mentores`, { params })
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

// export const createMentoring = async (data: FormData) => {
//   return await api.post(`/mentorias/cadastrar`, data, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   })
// }

export const createMentoring = async (data: FormData) => {
  return await api_v2.post(`/mentoria`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const updateMentoring = async (mentoriaId: number, data: FormData) => {
  try {
    const response = await api_v2.put(`/mentoria/${mentoriaId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  } catch (error) {
    console.error("Error updating mentoring:", error)
    throw error
  }
}
